import React, { useEffect, useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

import {
  UPDATE_LANDING_PAGE_PERMISSION,
  GET_LANDING_PAGE_PERMISSION,
} from "../../../ReduxStore/Slice/Admin/AdminHelpSlice";

import {
  CREATE_PLAN,
  GET_ALL_PLANS,
  UPDATE_PLAN,
  DELETE_PLAN,
} from "../../../ReduxStore/Slice/Admin/planSlice";

function Landing_page_setting() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("superadmin_token");

  const adminPlanState = useSelector((state) => state.adminPlan || {});

  const plans = adminPlanState.plans ||
    adminPlanState.data?.plans ||
    adminPlanState.allPlans ||
    [];

  const planLoading = adminPlanState.loading || false;
  const [localPlans, setLocalPlans] = useState([]);

  const [permissions, setPermissions] = useState([
    { key: "plan_permission", label: "Plan Permission", value: 0 },
    { key: "Marketplace_permission", label: "FAQ Permission", value: 0 },
  ]);

  const [fetchLoading, setFetchLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  // Plan Form States
  const [formData, setFormData] = useState({
    plan_name: "",
    plan_price: "",
    currency: "INR",
    plan_duration: "",
    plan_type: "basic",
    plan_description: "",
    is_active: 1,
  });


  const [features, setFeatures] = useState([""]);
  const [editMode, setEditMode] = useState(false);
  const [editingPlanId, setEditingPlanId] = useState(null);
  const [planSubmitLoading, setPlanSubmitLoading] = useState(false);

  // Modal State
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchPermissions();
  }, []);

  useEffect(() => {
    const planPermission = permissions.find((p) => p.key === "plan_permission");
    if (planPermission && planPermission.value === 1) {
      fetchPlans();
    }
  }, [permissions]);

  const fetchPermissions = async () => {
    setFetchLoading(true);
    try {
      const res = await dispatch(GET_LANDING_PAGE_PERMISSION({ token })).unwrap();

      if (res?.success && res.data) {
        const updated = permissions.map((item) => ({
          ...item,
          value: res.data[item.key] ?? 0,
        }));
        setPermissions(updated);
      }
    } catch (error) {
      toast.error(error?.msg || "Failed to load permissions");
    } finally {
      setFetchLoading(false);
    }
  };

  const fetchPlans = async () => {
    try {
      const res = await dispatch(GET_ALL_PLANS({ token })).unwrap();

      if (res?.data && Array.isArray(res.data)) {
        setLocalPlans(res.data);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const handleToggle = (index) => {
    const updated = [...permissions];
    updated[index].value = updated[index].value === 1 ? 0 : 1;
    setPermissions(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const finalData = {};
    permissions.forEach((p) => {
      finalData[p.key] = p.value;
    });

    try {
      const res = await dispatch(
        UPDATE_LANDING_PAGE_PERMISSION({
          data: finalData,
          token: token,
        })
      ).unwrap();

      if (res.success) {
        toast.success("Permissions updated successfully!");
      } else {
        toast.error(res.msg || "Failed to update permissions");
      }
    } catch (error) {
      toast.error(error?.msg || "Server Error!");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFeatureChange = (index, value) => {
    const updatedFeatures = [...features];
    updatedFeatures[index] = value;
    setFeatures(updatedFeatures);
  };

  const addFeatureField = () => {
    setFeatures([...features, ""]);
  };

  const removeFeatureField = (index) => {
    const updatedFeatures = features.filter((_, i) => i !== index);
    setFeatures(updatedFeatures);
  };

  const resetPlanForm = () => {
    setFormData({
      plan_name: "",
      plan_price: "",
      currency: "INR",
      plan_duration: "",
      plan_description: "",
      plan_type: "basic",
      is_active: 1,
    });
    setFeatures([""]);
    setEditMode(false);
    setEditingPlanId(null);
    setShowModal(false);
  };

  const handleEdit = (plan) => {
    setFormData({
      plan_name: plan.plan_name,
      plan_price: plan.plan_price.toString(),
      currency: plan.currency || "INR",
      plan_duration: plan.plan_duration.toString(),
      plan_description: plan.plan_description || "",
      plan_type: plan.plan_type,
      is_active: plan.is_active,
    });
    setFeatures(plan.plan_features.length > 0 ? plan.plan_features : [""]);
    setEditMode(true);
    setEditingPlanId(plan._id);
    setShowModal(true);
  };

  const handleDelete = async (id, planName) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      html: `You want to delete "<strong>${planName}</strong>"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        popup: 'swal2-custom-popup',
        confirmButton: 'btn btn-danger px-4',
        cancelButton: 'btn btn-secondary px-4'
      },
      buttonsStyling: false
    });

    if (result.isConfirmed) {
      try {
        const res = await dispatch(DELETE_PLAN({ id, token })).unwrap();
        if (res.success) {
          Swal.fire({
            title: 'Deleted!',
            text: 'Plan has been deleted successfully.',
            icon: 'success',
            confirmButtonColor: '#0d6efd',
            timer: 2000,
            customClass: {
              confirmButton: 'btn btn-primary px-4'
            },
            buttonsStyling: false
          });
          fetchPlans();
        }
      } catch (error) {
        Swal.fire({
          title: 'Error!',
          text: error?.msg || 'Failed to delete plan',
          icon: 'error',
          confirmButtonColor: '#0d6efd',
          customClass: {
            confirmButton: 'btn btn-primary px-4'
          },
          buttonsStyling: false
        });
      }
    }
  };

  const handlePlanSubmit = async (e) => {
    e.preventDefault();

    if (!formData.plan_name || !formData.plan_price || !formData.plan_duration) {
      toast.error("Please fill all required fields");
      return;
    }

    setPlanSubmitLoading(true);

    const filteredFeatures = features.filter((f) => f.trim() !== "");

    const planData = {
      ...formData,
      plan_features: filteredFeatures,
      plan_price: parseFloat(formData.plan_price),
      plan_duration: parseInt(formData.plan_duration),
    };

    try {
      if (editMode) {
        const res = await dispatch(
          UPDATE_PLAN({ id: editingPlanId, data: planData, token })
        ).unwrap();

        if (res.success) {
          toast.success("Plan updated successfully!");
          resetPlanForm();
          fetchPlans();
        }
      } else {
        const res = await dispatch(CREATE_PLAN({ data: planData, token })).unwrap();

        if (res.success) {
          toast.success("Plan created successfully!");
          resetPlanForm();
          fetchPlans();
        }
      }
    } catch (error) {
      toast.error(error?.msg || "Server Error!");
    } finally {
      setPlanSubmitLoading(false);
    }
  };

  const isPlanPermissionEnabled = permissions.find(
    (p) => p.key === "plan_permission"
  )?.value === 1;

  const displayPlans = plans.length > 0 ? plans : localPlans;

  if (fetchLoading) {
    return (
      <Content Page_title="Landing Page Settings" button_status={false}>
        <div className="container-fluid">
          <div className="card shadow-sm p-4 text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted">Loading permissions...</p>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content Page_title="Landing Page Settings" button_status={false}>
      <div className="container-fluid">
        {/* Permission Settings Card */}
        <div className="card shadow-sm p-4 mb-4">
          <form onSubmit={handleSubmit}>
            {permissions.map((item, index) => (
              <div
                className="d-flex justify-content-between align-items-center border-bottom py-3"
                key={index}
              >
                <div>
                  <h6 className="m-0">{item.label}</h6>
                  <small className="text-muted">
                    {item.value === 1 ? (
                      <span className="text-success">✓ Currently Enabled</span>
                    ) : (
                      <span className="text-danger">✗ Currently Disabled</span>
                    )}
                  </small>
                </div>

                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    checked={item.value === 1}
                    onChange={() => handleToggle(index)}
                    style={{ cursor: "pointer", width: "50px", height: "25px" }}
                    disabled={submitLoading}
                  />
                </div>
              </div>
            ))}

            <div className="d-flex gap-2 mt-4">
              <button
                className="btn btn-primary px-4"
                type="submit"
                disabled={submitLoading}
              >
                {submitLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving...
                  </>
                ) : (
                  "Save All Permissions"
                )}
              </button>

              <button
                className="btn btn-outline-secondary px-4"
                type="button"
                onClick={fetchPermissions}
                disabled={submitLoading || fetchLoading}
              >
                Refresh
              </button>
            </div>
          </form>
        </div>

        {/* Plan Management Section */}
        {isPlanPermissionEnabled && (
          <div className="row">
            <div className="col-md-12 mb-3">
              <button
                className="btn btn-success px-4"
                onClick={() => {
                  resetPlanForm();
                  setShowModal(true);
                }}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Create New Plan
              </button>
            </div>


            <div className="col-md-12">
              <div className="card shadow-sm p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="m-0">Existing Plans ({displayPlans.length})</h5>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={fetchPlans}
                    disabled={planLoading}
                  >
                    {planLoading ? "Loading..." : "Refresh"}
                  </button>
                </div>

                <div style={{ maxHeight: "600px", overflowY: "auto" }}>
                  {planLoading && displayPlans?.length === 0 ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : displayPlans.length === 0 ? (
                    <div className="text-center py-5">
                      <i className="bi bi-inbox" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                      <p className="text-muted mt-3">No plans created yet</p>
                    </div>
                  ) : (
                    <div className="row">
                      {displayPlans.map((plan) => (
                        <div key={plan._id} className="col-md-6 col-lg-4 mb-3">
                          <div className="card h-100 border shadow-sm hover-shadow" style={{ transition: "all 0.3s" }}>
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-start mb-3">
                                <div>
                                  <h5 className="card-title mb-1 fw-bold">{plan.plan_name}</h5>
                                  <h3 className=" mb-0 fs-4">
                                   <span className="fs-5 me-1"> {plan?.currency === "INR" ? "₹" : "$"}</span>
                                    <span className="fw-bold">{plan.plan_price}</span>
                                    <small className="text-muted fs-6">
                                      /{plan.plan_duration} month
                                    </small>
                                  </h3>

                                </div>
                                <div>
                                  <span
                                    className={`badge ${plan.is_active ? "bg-success" : "bg-secondary"
                                      } mb-1`}
                                  >
                                    {plan.is_active ? "Active" : "Inactive"}
                                  </span>
                                  <br />
                                  <span className="badge bg-info">
                                    {plan.plan_type}
                                  </span>
                                </div>
                              </div>

                              {plan.plan_description && (
                                <p className="card-text text-muted small mb-3">
                                  {plan.plan_description}
                                </p>
                              )}

                              {plan.plan_features && plan.plan_features.length > 0 && (
                                <div className="mb-3">
                                  <small className="text-muted fw-bold">Features:</small>
                                  <ul className="small mb-0 mt-1 ps-3">
                                    {plan.plan_features.slice(0, 3).map((feature, idx) => (
                                      <li key={idx} className="text-muted">{feature}</li>
                                    ))}
                                    {plan.plan_features.length > 3 && (
                                      <li className="text-muted">+{plan.plan_features.length - 3} more</li>
                                    )}
                                  </ul>
                                </div>
                              )}


                            </div>
                            <div className="d-flex gap-2 mt-3 p-2">
                              <button
                                className="btn btn-sm btn-primary flex-fill"
                                onClick={() => handleEdit(plan)}
                              >
                                <i className="bi bi-pencil me-1"></i>
                                Edit
                              </button>
                              <button
                                className="btn btn-sm btn-danger flex-fill"
                                onClick={() =>
                                  handleDelete(plan._id, plan.plan_name)
                                }
                              >
                                <i className="bi bi-trash me-1"></i>
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {!isPlanPermissionEnabled && (
          <div className="alert alert-info" role="alert">
            <i className="bi bi-info-circle me-2"></i>
            Plan management is currently disabled. Enable "Plan Permission" above to
            manage plans.
          </div>
        )}
      </div>

      {/* Modal for Create/Edit Plan */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editMode ? "Edit Plan" : "Create New Plan"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={resetPlanForm}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <form onSubmit={handlePlanSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Plan Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="plan_name"
                      value={formData.plan_name}
                      onChange={handleInputChange}
                      placeholder="e.g., Gold Plan"
                      required
                    />
                  </div>

                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Currency *</label>
                      <select
                        className="form-select"
                        name="currency"
                        value={formData.currency}
                        onChange={handleInputChange}
                      >
                        <option value="INR">₹ INR</option>
                        <option value="USD">$ USD</option>
                      </select>
                    </div>
                    <div className="col-md-5 mb-3">
                      <label className="form-label">Plan Price *</label>
                      <input
                        type="number"
                        className="form-control"
                        name="plan_price"
                        value={formData.plan_price}
                        onChange={handleInputChange}
                        placeholder="e.g., 99"
                        min="0"
                        step="0.01"
                        required
                      />
                    </div>

                    <div className="mb-3 col-md-4 ">
                      <label className="form-label">Plan Duration *</label>
                      <select
                        className="form-select"
                        name="plan_duration"
                        value={formData.plan_duration}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select Duration</option>
                        <option value="1">1 Month</option>
                        <option value="3">3 Months</option>
                        <option value="6">6 Months</option>
                        <option value="12">1 Year</option>
                      </select>
                    </div>

                  </div>

                  {/* <div className="mb-3">
                    <label className="form-label">Plan Type</label>
                    <select
                      className="form-select"
                      name="plan_type"
                      value={formData.plan_type}
                      onChange={handleInputChange}
                    >
                      <option value="basic">Basic</option>
                      <option value="premium">Premium</option>
                      <option value="enterprise">Enterprise</option>
                    </select>
                  </div> */}

                  <div className="mb-3">
                    <label className="form-label">Features</label>
                    {features.map((feature, index) => (
                      <div key={index} className="input-group mb-2">
                        <input
                          type="text"
                          className="form-control"
                          value={feature}
                          onChange={(e) =>
                            handleFeatureChange(index, e.target.value)
                          }
                          placeholder={`Feature ${index + 1}`}
                        />
                        {features.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => removeFeatureField(index)}
                          >
                            <i className="bi bi-x-lg"></i>
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={addFeatureField}
                    >
                      <i className="bi bi-plus-circle me-1"></i>
                      Add Feature
                    </button>
                  </div>


                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      name="plan_description"
                      value={formData.plan_description}
                      onChange={handleInputChange}
                      rows="3"
                      placeholder="Describe your plan..."
                    ></textarea>
                  </div>


                  <div className="mb-3 form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="is_active"
                      checked={formData.is_active === 1}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          is_active: e.target.checked ? 1 : 0,
                        })
                      }
                    />
                    <label className="form-check-label">Active Plan</label>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={resetPlanForm}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={planSubmitLoading}
                    >
                      {planSubmitLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          {editMode ? "Updating..." : "Creating..."}
                        </>
                      ) : (
                        <>
                          <i className="bi bi-check-circle me-1"></i>
                          {editMode ? "Update Plan" : "Create Plan"}
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .hover-shadow:hover {
          transform: translateY(-5px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }
        
        .swal2-custom-popup {
          border-radius: 15px;
        }
      `}</style>
    </Content>
  );
}

export default Landing_page_setting;